parasails.registerPage('mypace', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: {
    eventIsLive: false,
    partIsLive: false,
    partIndex: 0,
    actualPartIndex: 0,
    groupIndex: 0,
    partType: '',
    questionGroupData: {},
    currentPartData: {},
    backgroundStyle: 'background-image: url("../images/Visibby汎用BG.png"); background-repeat: no-repeat; background-position: center; background-size: cover; position: fixed;',
    puzzlebgstyle: 'background-color: #000000',
    regularbgstye: 'background-image: url("../images/Visibby汎用BG.png"); background-repeat: no-repeat; background-position: center; background-size: cover; position: fixed;',
    additionalstyle: 'background-repeat: no-repeat; background-position: center; background-size: cover; position: fixed;',
    surveyFractionStyle: '',
    eventLogo: 'images/caramel-logo.png',
    pleaseWait: true,
    showResults: false, //used here to determine the final "thank you" message.
    surveyResults: {},
    currentPuzzle: 0,
    crosswordsCompleted: [],
    allCrosswordsComplete: false,
    giftReceived: false,
    giftCode: '000000',
    showHintPanel: false,
    isValid: false,
    scrollbuttonpages: ['anket', 'puzzle'],
    shouldshowscrollbutton: false,
    noFractionImageStyle: 'fa-solid fa-pen',
    sideScrollImageStyle: 'background-image: url(../images/arrow.svg) !important;',
    //showCrosswordInput: false,
    // currentSelectedHint: {
    //   hint: '',
    //   letters: 0,
    //   crosswordindex: 0,
    //   questionnumber: 0,
    // },
    // currentAnswersGrid: []
  },

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  beforeMount: function() {
    //…
  },
  mounted: async function() {
    //document.addEventListener('visibilitychange', this.visChanged, false);
    // document.body.addEventListener('touchmove', this.preventDefault(), { passive: false });
    const urlParams = new URLSearchParams(window.location.search);
    this.overallEventID = urlParams.get('eventID');
    this.eventID = this.eventData.id;
    this.setBGStyle(false);
    this.setLogo();

    if(this.eventData.eventType.length > 0) {
      this.eventType = this.eventData.eventType[0].name;
      this.deviceidentifier = this.eventData.deviceidentifier;
      this.eventIsLive = this.eventData.isLive;
    }
    if(this.eventData.parts.length > 0) {
      for(var pi = 0; pi < this.eventData.parts.length; pi++) {
        if(this.eventData.parts[pi].isLive) {
          this.partIndex = pi;
          break;
        }
      }
      if(!this.partIndex) {this.partIndex = 0;}

      //Survey results
      if(this.eventData.surveyResultsData) {
        this.giftReceived = this.eventData.surveyResultsData.giftreceived;
        this.giftCode = this.eventData.surveyResultsData.giftCode;
      }

      if(this.alreadyResponded === true) {
        this.partIndex = this.eventData.parts.length - 1;
      }
      await this.setCurrentPart(this.partIndex);

      // this.currentPartData = this.eventData.parts[this.partIndex];
      // this.partIsLive = this.currentPartData.isLive;
      // this.questionGroupData = this.currentPartData.questiongroups;
      // this.clickSignalTime = (this.currentPartData.clickSignalTime) ? this.currentPartData.clickSignalTime : 0;

      // this.setBGStyle(false);

      // //--------------------------------------------------------------------------------
      // this.partType = this.currentPartData.partType.toLowerCase();
      // switch(this.partType) {
      //   case 'anket':
      //     if(this.currentPartData.questiongroups && this.currentPartData.questiongroups.length > 0) {
      //       this.setCurrentPage(this.partIndex, this.groupIndex);
      //     }
      //     break;
      //   case 'puzzle':
      //     this.setCrosswordsCompleted();
      //     break;
      //   default:
      //     this.partType = this.eventType;
      // }

      // this.setupCurrentAnswerGrid();
    } else {
      //console.log('event has no parts data');
    }

    io.socket.on(this.eventData.id, (params) => {
      // console.log('Received Socket Event with params: ' + JSON.stringify(params));
      switch(params.eventType) {
        case 'startevent':
          this.setBGStyle(false);
          this.partIsLive = false;
          this.eventIsLive = true;
          break;
        case 'endevent':
          this.setBGStyle(false);
          this.partIsLive = false;
          this.eventIsLive = false;
          break;
        case 'startpart':
          this.partIsLive = true;
          this.pleaseWait = true;
          this.partIndex = params.partIndex;
          this.currentPartData = this.eventData.parts[this.partIndex];
          this.currentPartData.isLive = true;
          this.setBGStyle(true);
          //--------------------------------------------------------------------------------
          this.partType = this.currentPartData.partType.toLowerCase();
          break;
        case 'endpart':
          this.setBGStyle(false);
          this.pleaseWait = true;
          this.partIsLive = false;
          break;
        case 'showresults':
        case 'pleasewait':
          this.showResults = true;
          break;
        case 'giftCodeGranted':
          if(params.deviceID === this.deviceidentifier) {
            console.log('Gift Code Granted message received for this device.');
            this.giftCode = params.giftCode;
            this.giftReceived = params.giftreceived;
          }
          break;
        case 'giftreceived':
          if(params.deviceID === this.deviceidentifier) {
            this.giftCode = params.giftCode;
            this.giftReceived = true;
            this.setGiftReceived();
          }
          break;
      }
    });

    this.$nextTick(() => {
      if($('#anketoverpanel')) { $('#anketoverpanel').scrollTop(1); }
      if($('#crosswordoverpanel')) { $('#crosswordoverpanel').scrollTop(1); }
      this.shouldshowscrollbutton = this.isOverflowing();
    });
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {
    async setCurrentPart(partIndex) {
      this.partIndex = partIndex;
      this.groupIndex = 0;
      this.actualPartIndex = 0;
      for(var i = 0; i < this.eventData.parts.length; i++) {
        if(this.eventData.parts[i].partIndex === partIndex) {
          this.actualPartIndex = i;
          break;
        }
      }

      this.currentPartData = this.eventData.parts[this.actualPartIndex];

      this.partIsLive = this.currentPartData.isLive;
      this.questionGroupData = this.currentPartData.questiongroups;
      this.clickSignalTime = (this.currentPartData.clickSignalTime) ? this.currentPartData.clickSignalTime : 0;
      //--------------------------------------------------------------------------------
      this.partType = this.currentPartData.partType.toLowerCase();

      //If this part has thankyoudata and hasgift is set to true, we can get the gift code imediately...
    //   "thankYouData" : {
    //     "message" : "Thank you!",
    //     "submessage" : "回答が送信されました。",
    //     "relatedpartindex" : NumberInt(1),
    //     "hasGift" : true,
    //     "giftInstructions" : "下のコードをスタッフに見せるとプレゼントが受け取れます。",
    //     "nomoregiftsInstructions" : "プレゼントは終了しました、申し訳ありません。 アンケートへのご協力ありがとうございました。",
    //     "giftsAvailable" : NumberInt(100)
    // },
      if(this.currentPartData.thankYouData && this.currentPartData.thankYouData.hasGift && this.currentPartData.thankYouData.hasGift === true) {
        //this part indicates we can get a gift code imediately...
        var giftCodeResults = await Cloud.getGiftCodeForDevice.with({
          eventID: this.eventID,
          deviceID: this.deviceidentifier
        });
        if(giftCodeResults) {
          this.giftCode = giftCodeResults.giftCode;
        }
        console.log("GIFT CODE SET TO " + this.giftCode);
      }

      switch(this.partType) {
        case 'anket':
          this.setBGStyle(true);
          if(this.questionGroupData && this.questionGroupData.length > 0) {
            this.setCurrentPage(this.actualPartIndex, this.groupIndex);
          }
          break;
        case 'puzzle':
          this.setBGStyle(true);
          this.setCrosswordsCompleted();
          break;
        case 'splash':
          this.setBGStyle(true);
          break;
        case 'thankyou':
          this.setBGStyle(true);
          if(this.giftCode === "000000") {
            var giftCodeResults = await Cloud.getGiftCodeForDevice.with({
              eventID: this.eventID,
              deviceID: this.deviceidentifier
            });
            if(giftCodeResults) {
              this.giftCode = giftCodeResults.giftCode;
            }
          }
          break;
        default:
          this.partType = this.eventType;
      }
      this.$nextTick(() => {
        if($('#anketoverpanel')) { $('#anketoverpanel').scrollTop(1); }
        if($('#crosswordoverpanel')) { $('#crosswordoverpanel').scrollTop(1); }
        this.shouldshowscrollbutton = this.isOverflowing();
      });
    },
    sleep: function(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    isOverflowing: function() {
      if(!this.scrollbuttonpages.includes(this.partType)) { return false; }
      switch(this.partType) {
        case 'anket':
          var lastAnketBottom = $('#INPUTSECTION').last('').children().last('').position().top + $('#INPUTSECTION').last('').children().last('').height();
          return (lastAnketBottom > $('#anketoverpanel').height());
        case 'puzzle':
          var $lastChild = $('#crossword' + this.currentPuzzle).children().last();
          var lastPuzzleBottom = 0;
          if ($lastChild.length) {
              // By checking for the element's existence, we prevent errors on page load.
              lastPuzzleBottom = $lastChild.position().top + $lastChild.height();
          }
          return (lastPuzzleBottom > $('#crosswordoverpanel').height());
          //return ($('#serviceicon_' + this.currentPuzzle).position().top > $('#crosswordoverpanel').height());
        default:
          console.log('Part Type was ' + this.partType);
          return false;
      }
    },
    setCurrentPage(partIndex, groupIndex, fromSocket = false)
    {
      this.pleaseWait = false;
      this.partIsLive = true;
      //this.partIndex = partIndex;
      this.groupIndex = groupIndex;
      for(var p in this.eventData.parts) {
        p.isLive = false;
      }
      this.currentPartData = this.eventData.parts[partIndex];
      this.currentPartData.isLive = true;
      this.validateSurvey();
      this.$nextTick(() => {
        if($('#anketoverpanel')) { $('#anketoverpanel').scrollTop(1); }
        if($('#crosswordoverpanel')) { $('#crosswordoverpanel').scrollTop(1); }
        this.shouldshowscrollbutton = this.isOverflowing();
      });
      // if(fromSocket === false) {
      //   for(var timmy = 0; timmy < this.eventData.parts[partIndex].questions.length; timmy++)
      //   {
      //     if(this.eventData.parts[partIndex].questions[timmy].isLive === true)
      //     {
      //       this.questionIndex = timmy;
      //       break;
      //     }
      //   }
      // }
      this.currentPartData.questions = this.eventData.parts[partIndex].questions;
    },
    validateSurvey() {
      var tmpIsValid = true;
      //Checks if all the required controls on the current group page have been filled in
      for(var qg of this.currentPartData.questiongroups[this.groupIndex].questions) {
        if(qg.required && qg.required === true) {
          if(qg.inputs[0].type === 'checkbox') {
            var secondaryValidator = false;
            //Checkboxes contain true or false, and only accept with input values or a final input...
            if(this.surveyResults[qg.identifier] && this.surveyResults[qg.identifier] !== '') {
              secondaryValidator = true;
            }

            if(secondaryValidator === false) {
              for(var ci = 0; ci < qg.inputs.length; ci++) {
                if(this.surveyResults[qg.identifier + '_' + String(ci)] && this.surveyResults[qg.identifier + '_' + String(ci)] === true) {
                  secondaryValidator = true;
                  break;
                }
              }
            }

            tmpIsValid = secondaryValidator;
            if(tmpIsValid === false) { break; }
          } else if((qg.inputs[0].type === 'select' && !this.surveyResults[qg.identifier + '_0'])
            || (qg.inputs[0].type !== 'select' && !this.surveyResults[qg.identifier])) {
            //Selects only have 1 input and it does not add to the data in the same way...
            tmpIsValid = false;
            break;
          }
        }
      }

      this.isValid = tmpIsValid;
    },
    scrollToMe(elementID) {
      console.log('Scroll to me!');
      var ref = document.getElementById(elementID);
      setTimeout(() => {
        ref.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 200);
    },
    nextPage() {
      this.groupIndex += 1;
      this.validateSurvey();
      this.$nextTick(() => {
        this.shouldshowscrollbutton = this.isOverflowing();
        $('#anketoverpanel').scrollTop(1);
      });
    },
    previousPage() {
      this.groupIndex -= 1;
      this.validateSurvey();
      this.$nextTick(() => {
        this.shouldshowscrollbutton = this.isOverflowing();
        $('#anketoverpanel').scrollTop(1);
      });
    },
    async submitResponses() {
      await io.socket.post('/surveyresponse', { eventid: this.eventID, partindex: this.partIndex, questionindex: this.questionIndex, deviceID: this.deviceidentifier, responsedata: this.surveyResults, giftCode: this.giftCode});
      this.nextPart();
    },
    setBGStyle(isPart) {
      var bgImage = '../images/Visibby汎用BG.png';
      this.surveyFractionStyle = '';
      // var additionalstyle = '-webkit-background-size: cover !important; -moz-background-size: cover !important; -o-background-size: cover !important; background-size: cover !important; background-repeat: no-repeat !important; background-color: #000000 !important; display: flex !important; align-items: center !important; align-content: center !important; justify-content: center !important; flex-wrap: nowrap !important; background-position: center !important;';
      if(isPart) {
        if(this.currentPartData) {
          if(this.currentPartData.BGImage && this.currentPartData.BGImage !== '') {
            bgImage = this.currentPartData.BGImage;
          }
          if(this.currentPartData.surveyOptions) {
            if(this.currentPartData.surveyOptions.fractionImage && this.currentPartData.surveyOptions.useFractionImage === true) {
              this.surveyFractionStyle = 'background-image: url(\'' + this.currentPartData.surveyOptions.fractionImage + '\') !important;';
            }
          }
          if(this.currentPartData.sideScrollImage) {
            this.sideScrollImageStyle = 'background-image: url(\'' + this.currentPartData.sideScrollImage + '\') !important;';
          } else {
            this.sideScrollImageStyle = 'background-image: url(../images/arrow.svg) !important;';
          }
        } else {
          if(this.eventData.BGImage && this.eventData.BGImage !== '') {
            bgImage = this.eventData.BGImage;
          }
        }
      }
      var bgimagegholder = (bgImage.toLowerCase().startsWith('background-color:')) ? bgImage : 'background-image: url(\'' + bgImage + '\') !important; ';
      // this.backgroundStyle = (this.currentPartData.partType === 'puzzle') ? this.puzzlebgstyle : bgimagegholder + this.additionalstyle;
      this.backgroundStyle = bgimagegholder + this.additionalstyle;
    },
    setLogo() {
      if(this.eventData.logoImage) {
        this.eventLogo = this.eventData.logoImage;
      }
    },
    setPuzzle(puzzleNumber) {
      this.currentPuzzle = puzzleNumber;
    },
    nextPart: function() {
      this.partIndex++;
      if(this.partIndex > this.eventData.parts.length) {
        //Do nothing
        this.partIndex--;
      } else {
        this.setCurrentPart(this.partIndex);
      }
      this.$nextTick(() => {
        if($('#anketoverpanel')) { $('#anketoverpanel').scrollTop(1); }
        if($('#crosswordoverpanel')) { $('#crosswordoverpanel').scrollTop(1); }
        this.shouldshowscrollbutton = this.isOverflowing();
      });
    },
    setCrosswordsCompleted: function() {
      for(var i = 0; i < this.currentPartData.crosswordData.length; i++) {
        this.crosswordsCompleted[i] = false;
      }
    },
    crosswordComplete: async function(crosswordIndex) {
      await io.socket.post('/surveyresponse', { eventid: this.eventID, partindex: this.partIndex, questionindex: this.questionIndex, deviceID: this.deviceidentifier, responsedata: this.surveyResults, giftCode: this.giftCode});
      this.crosswordsCompleted[crosswordIndex] = true;
      this.allCrosswordsComplete = true;
      // var hasIncomplete = false;
      // for(var cwc of this.crosswordsCompleted) {
      //   if(cwc === false) {hasIncomplete = true;}
      // }
      // this.allCrosswordsComplete = !hasIncomplete;
    },
    crosswordIncomplete: function(crosswordIndex) {
      this.crosswordsCompleted[crosswordIndex] = false;
      this.allCrosswordsComplete = false;
    },
    setGiftReceived: function() {
      //TODO: Add worker for gift received. Check the code to make sure just this one...
      //Check the deviceID and the code
      this.giftReceived = true;
    },
    checkGiftReceived: function() {
      this.giftReceived = true;
    },
    inputClicked: function(crosswordIndex, questionNumber) {
      // this.currentSelectedHint.hint = this.currentPartData.crosswordData[crosswordIndex].hints[questionNumber - 1].hint;
      // this.currentSelectedHint.letters = this.currentPartData.crosswordData[crosswordIndex].hints[questionNumber - 1].answer.length;
      // this.currentSelectedHint.crosswordindex = crosswordIndex;
      // this.currentSelectedHint.questionnumber = questionNumber;
      // this.showCrosswordInput = true;
    },
    // fillInput: function(inputText, crosswordindex, questionnumber) {
    //   console.log('Got fill input of ' + inputText); //TODO: Remove this when it all works
    //   console.log('got crosswordindex of ' + crosswordindex); //TODO: Remove this when it all works
    //   console.log('got questionnumber of ' + questionnumber); //TODO: Remove this when it all works
    //   this.showCrosswordInput = false;
    //   var indexer = 'cw_' + crosswordindex;
    //   console.log('indexer = ' + indexer);
    //   this.$refs['cw_1'].fillvalue; //TODO: Fix this. It does not work.
    //   //document.getElementById(indexer).call= 'fillValue("test")';
    // }
  }
});

// splashScreenOptions:
// "logo" : "../images/customerlogos/yoko-A-2-4C.png",
// "showLogo" : true,
// "titleMessage" : "ようこそ！",
// "subText" : "",
// "displaySeconds" : 3.0,
// "tabToContinue": true,
// "showNextButton": true,
// "nextButtonText": "次へ"
